'use client';

import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

export function NosOutreachNavigation() {
	return (
		<nav className="flex items-center justify-between px-6 py-4 bg-white/80 backdrop-blur-sm border-b border-orange-200">
			<div className="flex items-center">
				<Link href="/nosoutreach" className="flex items-center gap-2">
					<div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-red-600 rounded-xl flex items-center justify-center shadow-md">
						<span className="text-white font-black text-xl tracking-wider">NOS</span>
					</div>
					<span className="text-xl font-bold text-gray-900">Outreach</span>
				</Link>
			</div>
			<div className="flex items-center space-x-4">
				<Link href="/login">
					<Button variant="ghost" className="text-gray-700 hover:text-orange-600">
						Sign In
					</Button>
				</Link>
				<Link href="/signup">
					<Button className="bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white">
						Get Started
					</Button>
				</Link>
			</div>
		</nav>
	);
}
